import { Box, Stack, Typography, Container } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import TelephoneInput from 'components/TelephoneInput';

import useDeviceDetect from 'hooks/useDeviceDetect';
import { IconTextBadge } from './IconTextBadge';

export const TrackNumberSection = observer(() => {
    const { t } = useTranslation();
    const { isMobile } = useDeviceDetect();

    return (
        <Box
            sx={{
                overflow: 'hidden',
                background: 'linear-gradient(180deg, #0C0F21 5.76%, #030106 24.68%, #0C0F21 100%)',
            }}
        >
            <Container
                sx={{
                    position: 'relative',
                    pt: { xs: '80px', lmd: '206px' },
                    '&.MuiContainer-root': {
                        px: { xs: '0', md: '40px' },
                    },
                }}
            >
                <Stack direction="row" sx={{ zIndex: 1 }}>
                    <Stack
                        direction={'column'}
                        justifyContent={'center'}
                        alignItems={{
                            xs: 'center',
                            md: 'flex-start',
                        }}
                        sx={{ width: { xs: '100%', lmd: '60%' }, mt: '0px', zIndex: 1 }}
                    >
                        <Box sx={{ width: { xs: '350px', md: '650px' } }}>
                            <Typography variant="h4" sx={{ fontSize: '38px', display: 'inline', fontWeight: 700, lineHeight: '47.5px' }}>
                                {t('TrackNumber p1')}{' '}
                            </Typography>
                            <Typography
                                sx={{
                                    fontSize: '38px',
                                    display: 'inline',
                                    fontWeight: 700,
                                    lineHeight: '47.5px',
                                    background: 'linear-gradient(125deg, #0A2693 0%, #01CFFE 23.96%, #F2D3CD 100%)',
                                    WebkitBackgroundClip: 'text',
                                    WebkitTextFillColor: 'transparent',
                                }}
                            >
                                {t('TrackNumber p2')}{' '}
                            </Typography>
                            <Typography sx={{ fontSize: '38px', display: 'inline', fontWeight: 700, lineHeight: '47.5px' }}>{t('TrackNumber p3')}</Typography>{' '}
                            <Typography sx={{ color: '#A3A5B0', fontSize: '20px', fontWeight: 300, mt: '20px', lineHeight: '25px' }}>
                                {t('TrackNumber label')}
                            </Typography>
                        </Box>

                        <Box sx={{ width: '350px' }}>
                            <TelephoneInput redirectPath="/search" disableClickEventSend />
                        </Box>
                        <Stack direction="row" gap={'20px'} marginTop={'40px'}>
                            <IconTextBadge
                                imageUrl={'/images/checked-shield-white.svg'}
                                title={t('SECURE')}
                                subtitle={t('SSL ENCRYPTION')}
                                borderColor={'#fff'}
                            />
                            <IconTextBadge imageUrl={'/images/lock-icon-white.svg'} title="100%" subtitle={t('CONFIDENTIAL')} borderColor={'#fff'} />
                        </Stack>
                    </Stack>
                    {!isMobile && (
                        <Box
                            sx={{
                                width: '50%',
                                flexShrink: 0,
                                zIndex: 1,
                            }}
                        >
                            <img src="/images/hero-phone.png" alt="" style={{ width: '100%' }} />
                        </Box>
                    )}
                </Stack>
            </Container>
            <Box
                sx={{
                    zIndex: 0,
                    position: 'relative',
                    mt: { xs: undefined, lmd: '-200px' },
                }}
            >
                <img
                    src={isMobile ? '/images/mob-hero-bg.png' : '/images/hero-earth.png'}
                    alt="globe illustration"
                    style={{
                        width: '100%',
                        height: 'auto',
                        marginBottom: '-7px',
                    }}
                />
                <Box
                    sx={{
                        height: '165px',
                        width: '100%',
                        position: 'absolute',
                        left: 0,
                        bottom: 0,
                        background: 'linear-gradient(180deg, rgba(12, 15, 33, 0) 0%, #0C0F21 100%)',
                    }}
                />
            </Box>
        </Box>
    );
});
